import { sum } from './statistics';
import { Vec2Like } from './vec-like';

//gets m and b from y=m*x+b for the given points
export function lineMAndB(points:Vec2Like[]){
	if(points.length===0)
		return undefined;
	const xSum=sum(points.map(p=>p.x));
	const ySum=sum(points.map(p=>p.y));
	const xySum=sum(points.map(p=>p.x*p.y));
	const xxSum=sum(points.map(p=>p.x*p.x));
	//const yySum=sum(points.map(p=>p.y*p.y));
	const ssxx=(xxSum-(xSum*xSum/points.length));
	//const ssyy=(yySum-(ySum*ySum/points.length));
	const ssxy=(xySum-(xSum*ySum/points.length));
	const m=ssxy/ssxx;
	const b=ySum/points.length-(xSum/points.length)*m;
	return {m,b};
}
